import React from 'react';
import './Home.css';
import {homeSections} from '../content/home/homeSections';

function Home() {
  return (
    <div className='home'>
      <div className='homepage'>
        <main>
          {homeSections
            .filter((s) => s.enabled)
            .map(({id, Component}) => (
              <section
                key={id}
                id={id}>
                <Component />
              </section>
            ))}
        </main>
      </div>
    </div>
  );
}

export default Home;
